import { Text } from '@chakra-ui/react';
import type React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sits under the plan-change control, not in the migration card: a merchant who
 * reaches for "Manage plan" must read there why Shopify will refuse until the
 * replacement takes effect.
 */
export const PlanChangeFrozenNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Text fontSize="sm" color="fg.muted" mt={2}>
      {t('settings.subscription.successFeeMigration.planChangeFrozen')}
    </Text>
  );
};
